import { render } from "./RuleDataTable.vue?vue&type=template&id=39ff9514&scoped=true"
import script from "./RuleDataTable.vue?vue&type=script&lang=js"
export * from "./RuleDataTable.vue?vue&type=script&lang=js"

import "./RuleDataTable.vue?vue&type=style&index=0&id=39ff9514&scoped=true&lang=css"

import exportComponent from "../../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ff9514"]])

export default __exports__